/* globals getApp  getCurrentPages */

import { init } from '@baidu/weirwood-mp-sdk/lib/bundle.swan.esm';

/**
 *
 * @description weirwood 初始化
 * 通过 init() 方法进行初始化，会生成默认的异常监控实例
 *
 */

const {
  reportException
} = {
  reportException: () => {}
};

/**
 *
 * @description weirwood JS 错误上报
 */
export const weirwoodErrorReport = async args => {
  const err = args.err || {};
  const pages = getCurrentPages();
  const page = pages[pages.length - 1] || {};
  reportException({
    page: page.uri,
    env: {},
    exception: {
      type: err.name,
      value: err.message
    },
    errorInstance: err
  });
};